<template>
  <context-menu
    :row="menuConf.row"
    :offset="offset"
    :items="items"
  ></context-menu>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ContextMenu from "@/components/base/contextMenu";
import MixFunc from "@/components/mixins/base";
export default {
  components: {
    ContextMenu,
  },
  computed: {
    ...mapState({
      menuConf: (state) => state.contextMenuConf,
      userInfo: (state) => state.user.userInfo,
    }),
    offset() {
      let bottom = 200,
        right = 500;
      if (this.menuConf.type === CONSTANT.MENU_TYPE.CREATIVE_FOLDER) {
        right = 200;
      }
      return { bottom, right };
    },
    items() {
      let items = [];
      if (this.menuConf.type === CONSTANT.MENU_TYPE.CREATIVE_FOLDER) {
        items = [
          {
            label: "Rename",
            icon: "fas fa-pen",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.CREATIVE_FOLDER,
                row,
              }),
          },
          {
            label: "Delete",
            icon: "fas fa-trash-alt",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.DELETE,
                row: {
                  item: CONSTANT.DIALOG_TYPE.CREATIVE_FOLDER,
                  id: row._id,
                  name: row.name,
                },
              }),
          },
        ];
      } else if (this.menuConf.type === CONSTANT.MENU_TYPE.ADVERTISER) {
        items = [
          {
            label: "Edit",
            icon: "fas fa-pen",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.ADVERTISER,
                row,
              }),
          },
        ];
      } else if (this.menuConf.type === CONSTANT.MENU_TYPE.CAMPAIGN) {
        items = [
          {
            label: "Edit",
            icon: "fas fa-pen",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.CAMPAIGN,
                row,
              }),
          },
        ];
      } else if (this.menuConf.type === CONSTANT.MENU_TYPE.CREATIVE_TABLE) {
        items = [
          {
            label: "Preview",
            icon: "fas fa-eye",
            click: (row) => this.openBlankPage(`/preview/${row.creative_id}`),
          },
          {
            label: "Copy tag",
            icon: "fas fa-clone",
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.CREATIVE_TEMPLATE,
                row,
              }),
          },
          {
            label: "Share preview link",
            icon: "fas fa-link",
            click: (row) =>
              this.copy(
                "preview link",
                `${config.dashboard_domain}/preview/${row.creative_id}`
              ),
          },
          {
            label: "Move to ...",
            icon: "fas fa-folder-open",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.SELECT_FOLDER,
                row: {
                  item: CONSTANT.DIALOG_TYPE.CREATIVE_FOLDER,
                  id: row._id,
                  folder: row.folder,
                },
              }),
          },
          {
            label: "Edit",
            icon: "fas fa-pen",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({ type: CONSTANT.DIALOG_TYPE.CREATIVE, row }),
          },
          {
            label: "Delete",
            icon: "fas fa-trash-alt",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.DELETE,
                row: {
                  item: CONSTANT.DIALOG_TYPE.CREATIVE,
                  id: row._id,
                  name: row.name,
                },
              }),
            divided: true,
          },
        ];
      } else if (this.menuConf.type === CONSTANT.MENU_TYPE.AUDIENCE) {
        items = [
          {
            label: "Edit",
            icon: "fas fa-pen",
            click: (row) =>
              this.showDialog({ type: CONSTANT.DIALOG_TYPE.AUDIENCE, row }),
          },
          {
            label: "Copy JS code",
            icon: "fas fa-clone",
            click: (row) => this.copy("JS code", row.jsTag),
          },
          {
            label: "Copy image pixel",
            icon: "fas fa-clone",
            click: (row) => this.copy("image pixel", row.imagePixel),
          },
        ];
      } else if (this.menuConf.type === CONSTANT.MENU_TYPE.ASSET) {
        items = [
          {
            label: "Edit",
            icon: "fas fa-pen",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({ type: CONSTANT.DIALOG_TYPE.ASSET, row }),
          },
          {
            label: "Delete",
            icon: "fas fa-trash-alt",
            disabled: !CONSTANT.USER_LEVEL_FILTER.MID.includes(
              this.userInfo.service.user_level
            ),
            click: (row) =>
              this.showDialog({
                type: CONSTANT.DIALOG_TYPE.DELETE,
                row: {
                  item: CONSTANT.DIALOG_TYPE.ASSET,
                  id: row._id,
                  name: row.name,
                },
              }),
            divided: true,
          },
        ];
      }
      return items;
    },
  },
  mixins: [MixFunc],
  methods: {
    ...mapActions({
      showDialog: "showDialog",
    }),
  },
};
</script>

<style></style>
